import { createAsyncThunk } from "@reduxjs/toolkit";
import { helpers } from "../../../packages/helpers";
import { AUTH_ACTIONS } from "../types";
import { getUserData } from "../providers";
import type { AuthQuery, AuthApiCallback } from "../types";

const { getActionErrorText } = helpers.error;

type ActionReturn = ReturnType<typeof getUserData>;
type ActionParams = { authApi: AuthApiCallback };

const QUERY: AuthQuery = { channel: "ul-lk" };

export const auth = createAsyncThunk<ActionReturn, ActionParams>(
  AUTH_ACTIONS.AUTH,
  async ({ authApi }) => {
    try {
      const resp = await authApi(QUERY);

      return getUserData(resp);
    } catch (error) {
      const text = getActionErrorText(error);

      throw new Error(text);
    }
  }
);
